<wiz-vgroup width="100%" height="100%" horizontalAlign="center" gap="0" class="insert clickable-widget">
  <wiz-hgroup width="100%" height="20px" verticalAlign="center" padding="3px" gap="2" class="insert-header">
    <wiz-icon *ngIf="isFD()">codifications</wiz-icon>
    <wiz-icon *ngIf="isChron()">chronocodes</wiz-icon>
    <wiz-label
      #lbTitle
      width="100%"
      [wizLabel]="data.parentFullLabel"
      [wizTextBehavior]="'truncate'"
      class="insert-title-12"
    ></wiz-label>
    <wiz-icon style="cursor: pointer" (click)="delPart()">close</wiz-icon>
  </wiz-hgroup>
  <wiz-hgroup width="100%" height="100%" verticalAlign="center" style="padding: 3px">
    <wiz-label
      width="100%"
      [wizLabel]="data.fullLabel"
      [wizTextBehavior]="'wordWrap'"
      [wizNbLine]="2"
      style="font-size: 9px"
    ></wiz-label>
  </wiz-hgroup>
</wiz-vgroup>
